export default /** @ngInject */ function($q, $http, config) {
    return {
        urlBase: config.accountsApiUrl + '/api/v1',
        request: (method = 'GET', url, data = {}, params = {}) => {
            let deferred = $q.defer();
            let request = {
                url: url,
                method: method,
                data: data,
                params: params
            };

            $http(request)
                .then((resp) => deferred.resolve(resp.data))
                .catch((resp) => deferred.reject(resp.data));

            return deferred.promise;
        }
    };
}



// WEBPACK FOOTER //
// ./utils/services/request.js